<template>
  <div class="contranter product-data">
    <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
    <div class="products-container">
      <div class="products">
        <div class="product" v-for="item in list">
          <div class="prod-img">
            <img :src="item.cover" />
          </div>
          <div class="prod-detail">
            <div class="prod-title">
              {{ item.name }}
            </div>
            <div class="prod-subtitle">
              {{ item.category }}
            </div>
          </div>
          <div class="prod-download"><img src="../assets/download.png" class="download" @click="download(item)" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from "../components/Topbar.vue";
import api from "../api/api";
import "swiper/dist/css/swiper.css";

export default {
  name: "Data",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "",
      tab_index: 4,
      had_login: false,
      list: [
        { category: "雅生奇特里奥C系列", name: "墙装头顶花洒单速", cover: require("../assets/products/28791.jpg"), download: "28791.zip" },
        { category: "ShowerSelect lD系列", name: "暗装两功能恒温龙头，柔和方形", cover: require("../assets/products/36754.jpg"), download: "36754.zip" },
        { category: "雅生奇特里奥C系列", name: "单把手面盆龙头125 冷启动，立方体切割设计把手，带提拉落水套件", cover: require("../assets/products/49031.jpg"), download: "49031.zip" },
        { category: "雅生奇特里奥C系列", name: "单把手面盆龙头250 冷启动，立方体切割设计把手，带长流水型落水套件", cover: require("../assets/products/49051.jpg"), download: "49051.zip" },
        { category: "雅生奇特里奥C系列", name: "三孔面盆龙头125，立方体切割设计把手，带提拉落水套件", cover: require("../assets/products/49061.jpg"), download: "49061.zip" },
        { category: "雅生奇特里奥C系列", name: "暗装墙出水两孔面盆龙头，带出水嘴195mm和立方体切割设计把手", cover: require("../assets/products/49111.jpg"), download: "49111.zip" },
        { category: "雅生奇特里奥C系列", name: "落地式单把手浴缸龙头，带立方体切割设计把手", cover: require("../assets/products/49441.jpg"), download: "49441.zip" },
        { category: "雅生奇特里奥C系列", name: "花洒支架套件 120/120 柔和方形，带棒式手持花洒 两速和织物纹理花洒软管", cover: require("../assets/products/49626.jpg"), download: "49626.zip" },
        { category: "AXOR Signature Plates", name: "雅生ShowerSelect ID特殊材质面板", cover: require("../assets/products/雅生ShowerSelectID特殊材质面板AXORSignaturePlates.jpg"), download: "雅生ShowerSelect ID特殊材质面板 AXOR Signature Plates.zip" },
        { category: "AXOR Signature Plates", name: "雅生真我系列特殊材质面板", cover: require("../assets/products/雅生真我系列特殊材质面板AXORSignaturePlates.jpg"), download: "雅生真我系列特殊材质面板 AXOR Signature Plates.zip" },

        { category: "AXOR FinishPlus", name: "雅生特殊表面颜色", cover: require("../assets/products/FinishPlus.jpg"), download: "FinishPlus.zip" },
        { category: "AXOR made by SCHOCK Color Sample ", name: "雅生石英石水槽色卡", cover: require("../assets/products/雅生石英石水槽色卡.jpg"), download: "雅生石英石水槽色卡.7z" },
        { category: "雅生真我系列", name: "单把手面盆龙头70带按压落水", cover: require("../assets/products/47010.jpg"), download: "47010.zip" },
        { category: "雅生真我系列", name: "单把手面盆龙头230带按压落水", cover: require("../assets/products/47020.jpg"), download: "47020.zip" },
        { category: "雅生真我系列", name: "落地式单把手面盆龙头带按压落水", cover: require("../assets/products/47040.jpg"), download: "47040.zip" },
        { category: "雅生真我系列", name: "墙装单把手面盆龙头", cover: require("../assets/products/47060.jpg"), download: "47060.zip" },
        { category: "雅生真我系列", name: "3孔面盆龙头70带按压落水", cover: require("../assets/products/47050.jpg"), download: "47050.zip" },
        { category: "雅生One系列", name: "面盆龙头Select 170带按压落水", cover: require("../assets/products/48020.jpg"), download: "48020.zip" },
        { category: "雅生One系列", name: "面盆龙头Select 260带长流水落水", cover: require("../assets/products/48030.jpg"), download: "48030.zip" },
        { category: "雅生One系列", name: "暗装墙出水单孔面盆龙头Select，出水嘴220mm", cover: require("../assets/products/48112.jpg"), download: "48112.zip" },
        { category: "雅生One系列", name: "3孔面盆龙头Select 130带按压落水", cover: require("../assets/products/48070.jpg"), download: "48070.zip" },
        { category: "雅生One系列", name: "面盆龙头Select 260带长流水落水", cover: require("../assets/products/48060.jpg"), download: "48060.zip" },
        { category: "雅生One系列", name: "单把面盆龙头70带提拉落水", cover: require("../assets/products/48000.jpg"), download: "48000.zip" },
        { category: "雅生One系列", name: "单把面盆龙头260带长流水落水", cover: require("../assets/products/48002.jpg"), download: "48002.zip" },
        { category: "雅生One系列", name: "3孔面盆龙头130带按压落水", cover: require("../assets/products/48050.jpg"), download: "48050.zip" },
        { category: "雅生One系列", name: "暗装墙出水单把面盆龙头，出水嘴220mm，带一字把手", cover: require("../assets/products/48120.jpg"), download: "48120.zip" },
        { category: "雅生One系列", name: "落地式单把手浴缸龙头", cover: require("../assets/products/48440.jpg"), download: "48440.zip" },
        { category: "雅生真我系列", name: "落地式单把手缸边龙头", cover: require("../assets/products/47440.jpg"), download: "47440.zip" },
        { category: "雅生真我系列", name: "4孔翻边安装浴缸龙头", cover: require("../assets/products/47430.jpg"), download: "47430.zip" },
        { category: "雅生套间台盆及浴缸", name: "面盆400 ，不带龙头安装孔和溢水孔", cover: require("../assets/products/42001.jpg"), download: "42001.zip" },
        { category: "雅生套间台盆及浴缸", name: "面盆400 /400，不带龙头安装孔和溢水孔", cover: require("../assets/products/42003.jpg"), download: "42003.zip" },
        { category: "雅生套间台盆及浴缸", name: "面盆600 /400，不带龙头安装孔和溢水孔", cover: require("../assets/products/42004.jpg"), download: "42004.zip" },
        { category: "雅生套间台盆及浴缸", name: "浴缸1900/850", cover: require("../assets/products/42005.jpg"), download: "42005.zip" },
        { category: "雅生套间台盆及浴缸", name: " 浴缸置物架", cover: require("../assets/products/42006.jpg"), download: "42006.zip" },
        { category: "雅生One系列", name: "头顶花洒280 2速带花洒臂", cover: require("../assets/products/48492.jpg"), download: "48492.zip" },
        { category: "雅生One系列", name: "暗装三功能恒温模块", cover: require("../assets/products/45713.jpg"), download: "45713.zip" },
        { category: "雅生One系列", name: "升降杆带墙面连接及软管", cover: require("../assets/products/48792.jpg"), download: "48792.zip" },
        { category: "雅生One系列", name: "单速手持花洒", cover: require("../assets/products/48651.jpg"), download: "48651.zip" },
        { category: "雅生斯达克淋浴解决方案", name: "淋浴板，带恒温淋浴龙头，头顶花洒110/220 单速和肩部花洒", cover: require("../assets/products/12595.jpg"), download: "12595.zip" },
        { category: "雅生斯达克淋浴解决方案", name: "淋浴模块250/250，带肩部花洒两速", cover: require("../assets/products/12594.jpg"), download: "12594.zip" },
        { category: "雅生斯达克淋浴解决方案", name: "暗装四功能恒温模块610/110", cover: require("../assets/products/12573.jpg"), download: "12573.zip" },
        { category: "雅生奇特里奥系列", name: "单把手厨房龙头230", cover: require("../assets/products/39840.jpg"), download: "39840.zip" },
        { category: "雅生奇特里奥系列", name: "Select单把手厨房龙头带拉出式喷头", cover: require("../assets/products/39861.jpg"), download: "39861.zip" },
        { category: "雅生奇特里奥系列", name: "单把手厨房龙头", cover: require("../assets/products/39850.jpg"), download: "39850.zip" },
        { category: "雅生水槽", name: "MONO R-100 CD 极光白（含自动下水）", cover: require("../assets/products/43009.jpg"), download: "43009.zip" },
        { category: "雅生水槽", name: "Waterfall D 150 CD 胭脂红（含自动下水）", cover: require("../assets/products/43022.jpg"), download: "43022.zip" },
        { category: "雅生水槽", name: "Signus N 100 XL CD 极光白（含自动下水）", cover: require("../assets/products/43031.jpg"), download: "43031.zip" },
        { category: "雅生水槽", name: "Mono N100 CD 木兰白（含自动下水）", cover: require("../assets/products/43036.jpg"), download: "43036.zip" },
      ],
    };
  },
  methods: {
    logoOut() {
      localStorage.removeItem("mobile");
      this.$router.push("/");
    },
    loadData() {
      let phone_number = localStorage.getItem("mobile");
      if (phone_number) {
        this.had_login = true;
      }
    },
    download(item) {
      location.href = "https://designhomenew.axor-design.com.cn/files/" + item.download;
      // location.href = "https://axor.dev.kai-dian.com/files/" + item.download;
      // this.$message("模拟下载：" + item.download);
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    let that = this;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-data {
  background: #e9e2d9;
}

.products-container {
  text-align: center;
  padding: 0.7rem auto;
  box-sizing: border-box;
  min-height: calc(100vh - 1.1rem);
  height: auto;
}

.products {
  width: 15rem;
  margin: 0 auto;
  padding: 0.7rem 0;
  display: grid;
  grid-template-columns: repeat(3, 4.8rem);
  grid-gap: 0.3rem;
  row-gap: 0.3rem;
}

.product {
  background: #fff;
  width: 4.8rem;
  height: 5.6rem;
  box-shadow: 0px 0.02rem 0.15rem rgba(0, 0, 0, 0.1);
  text-align: center;
}

.prod-img {
  width: 4.8rem;
  height: 3.4rem;
  text-align: center;
  padding-top: 0.2rem;
}

.prod-img img {
  width: 60%;
  margin: 0 auto;
  margin-top: 10%;
}

.prod-detail {
  text-align: left;
  margin: 0 0.47rem;
  height: 1.4rem;
  padding-bottom: 0.08rem;
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}

.prod-title {
  font-size: 0.24rem;
  margin-bottom: 0.08rem;
}

.prod-subtitle {
  font-size: 0.18rem;
}

.prod-download {
  text-align: center;
  cursor: pointer;
}

.download {
  margin: 0 auto;
  margin-top: 0.1rem;
  width: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Data.vue